import React from 'react';
import { siteData } from '../data';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <div className="relative pt-20 overflow-hidden bg-white">
      <div className="grid lg:grid-cols-2 items-stretch">
        <motion.div 
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="flex items-center justify-start lg:justify-end px-4 sm:px-6 lg:px-8 py-12 sm:py-20 lg:py-40"
        >
          <div className="w-full max-w-xl">
            <h1 className="text-3xl sm:text-4xl lg:text-6xl font-extrabold text-gray-900 tracking-tight leading-[1.1] mb-4">
              {siteData.tagline}
            </h1>
            <p className="text-lg sm:text-xl text-gray-600 mb-8 leading-relaxed">
              {siteData.description}
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link 
                to="/kontakt"
                className="inline-flex items-center justify-center bg-blue-600 text-white px-8 py-4 text-sm md:px-5 md:py-3 md:text-base lg:px-6 lg:py-3 lg:text-base xl:px-8 xl:py-4 xl:text-lg rounded-none font-bold transition-all shadow-lg hover:-translate-y-1 group"
              >
                Bestil vinduespudser her
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Link>
              <Link 
                to="/kontakt"
                className="inline-flex items-center justify-center bg-transparent text-gray-900 px-8 py-4 text-sm md:px-5 md:py-3 md:text-base lg:px-6 lg:py-3 lg:text-base xl:px-8 xl:py-4 xl:text-lg rounded-none font-bold border-2 border-black transition-all hover:-translate-y-1"
              >
                Få et gratis tilbud
              </Link>
            </div>
          </div>
        </motion.div>
        
        <motion.div 
          initial={{ opacity: 0, scale: 1.05 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          className="relative h-[500px] lg:h-auto lg:min-h-[750px]"
        >
          <img 
            src={siteData.images.hero} 
            alt="Professionel vinduespudser" 
            className="absolute inset-0 h-full w-full object-cover"
          />
        </motion.div>
      </div>
    </div>
  );
}
